import(/* webpackMode: "eager" */ "/app/apps/web/src/app/uat/[institutionSlug]/new-payment/[formSlug]/page.tsx");
